<template>
	<div class="row" style="height: 100%" :key="modalKey">
		<div class="col-sm-12 col-md-12 col-lg-7 col-xl-8 pr-0" id="left-panel" style="display: flex; flex-direction: column;">
			<div class="bg-dark-noise modal-topbar p-2" style="display: flex; flex-direction: row;">
				<div class="d-flex justify-content-start align-self-center">
					<div @click="close" class="modal-button-sm modal-button--white"><i class="fas fa-times"></i></div>
				</div>
				<div class="d-flex justify-content-center align-self-center" style="flex-grow: 100;">
					<div @click="prev(image.type + '-' + image.id)" class="modal-button-sm modal-button--white align-self-center" :class="{'modal-button--disabled' : hasPrev(image.type + '-' + image.id) === null}"><i class="fas fa-chevron-left"></i></div>
					<div class="modal-title text-white mx-2"><b>{{image.image_id}}</b></div>
					<div @click="next(image.type + '-' + image.id)" class="modal-button-sm modal-button--white align-self-center" :class="{'modal-button--disabled' : hasNext(image.type + '-' + image.id) === null}"><i class="fas fa-chevron-right"></i></div>
				</div>
				<div class="float-right mr-2">
					<button class="btn btn-outline-light btn-sm btn-report" type="button" @click="$bvModal.show('report-issue-modal')" :disabled="image.is_reported === 1">{{ __('translations.button.report') }}</button>
				</div>
			</div>
			<div id="openseadragon" ref="osd"></div>
			<div class="openseadragon-controls">
				<div id="zoom-in" class="modal-button control-button"><i class="fas fa-search-plus"></i></div>
				<div id="home" class="modal-button control-button"><i class="fas fa-home"></i></div>
				<div id="zoom-out" class="modal-button control-button"><i class="fas fa-search-minus"></i></div>
			</div>
		</div>
		<div class="col-sm-0 col-md-0 col-lg-5 col-xl-4 pl-0" id="right-panel">
			<transition name="component-fade" mode="out-in">
				<div v-if="!wikidataSearchFlag && !annotationFormFlag" style="height: 100%; display: flex; flex-direction: column;">
					<div class="bg-light-noise modal-topbar py-2">
						<div class="navbar modal-topbar-content" role="tablist">
							<a class="nav-link text-dark p-0 mr-3" :class="{'active' : activeTab === 'general'}" @click="activeTab = 'general'" id="general-tab" data-toggle="tab" href="#general" role="tab" aria-controls="general" aria-selected="true">{{ __('translations.tab.general') }}</a>
							<a class="nav-link text-dark p-0 mr-3" :class="{'active' : activeTab === 'annotation'}" @click="activeTab = 'annotation'" id="annotation-tab" data-toggle="tab" href="#annotation" role="tab" aria-controls="annotation" aria-selected="false">{{ __('translations.tab.annotation') }}<span v-show="image.annotations.length > 0">&nbsp;({{image.annotations.length}})</span></a>
							<a class="nav-link text-dark p-0 mr-3" :class="{'active' : activeTab === 'history'}" @click="activeTab = 'history'" id="history-tab" data-toggle="tab" href="#history" role="tab" aria-controls="history" aria-selected="false">{{ __('translations.tab.history') }}</a>
							<a class="nav-link text-dark p-0" v-if="image.suggestions && image.suggestions.length > 0" :class="{'active' : activeTab === 'issues'}" @click="activeTab = 'issues'" id="issue-reported-tab" data-toggle="tab" href="#issues" role="tab" aria-controls="issues" aria-selected="false">Problèmes</a>
						</div>
					</div>
					<div class="tab-content p-3" style="flex: 1; overflow-y: auto; overflow-x: hidden;" ref="tab-content">
						<div class="tab-pane fade" :class="{'show active' : activeTab === 'general'}" id="general" role="tabpanel" aria-labelledby="general-tab">
							<transition name="message-fade">
								<div v-if="image.is_reported === 1" class="alert alert-warning py-1" role="alert">
									<small>{{ __('translations.message.image_issue') }} {{ __('translations.issue_type.' + image.reported_issue_type) }}</small>
								</div>
							</transition>
							<image-info :image="image"></image-info>
							<wikidata-tags :image="image"></wikidata-tags>
						</div>
						<div class="tab-pane fade" :class="{'show active' : activeTab === 'annotation'}" id="annotation" role="tabpanel" aria-labelledby="annotation-tab">
							<annotations :artifact="image" v-on:annotation-selected="onAnnotationSelected"></annotations>
						</div>
						<div class="tab-pane fade" :class="{'show active' : activeTab === 'history'}" id="history" role="tabpanel" aria-labelledby="history-tab">
							<activity-logs :artifact="image" v-if="activeTab === 'history'"></activity-logs>
						</div>
						<div class="tab-pane fade" :class="{'show active' : activeTab === 'issues'}" id="issues" role="tabpanel" aria-labelledby="issue-reported-tab">
							<reported-issues v-if="activeTab === 'issues'" v-on:unreported="onUnreported"></reported-issues>
						</div>
					</div>
				</div>
				<div class="wikidata-search-container" v-else-if="wikidataSearchFlag">
					<div class="bg-light-noise modal-topbar pl-3 py-2" style="display: flex; flex-direction: row;">
						<div class="modal-topbar-content"><b>{{ __('translations.title.wikidata_search') }}</b></div>
						<div class="d-flex justify-content-end align-self-center p-2" @click="hideWikidataSearch" style="flex-grow: 100;">
							<i class="fas fa-times fa-lg p-2" style="cursor: pointer;"></i>
						</div>
					</div>
					<div style="flex-grow: 100%; overflow: hidden;" class="p-3">
						<wikidata-search :taggableType="image.type"
							v-on:selected-tag="onSelectedTag"
							v-on:deselected-tag="onDeselectedTag"
							:populateWith="image.tags"></wikidata-search>
					</div>
				</div>
				<component v-else-if="annotationFormFlag" v-bind:is="annotationFormComponent" :artifact="image" :populateWith="annotationSelected" ref="annotationForm"></component>
			</transition>
		</div>
		
		<report-issue :artifact="image" v-on:reported="onReported"></report-issue>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
import ImageInfo from './ImageInfo'
import WikidataTags from './WikidataTags'
import WikidataSearch from './WikidataSearch'
import ModalMixin from '../mixins/ModalMixin'
import ReportedIssues from './ReportedIssues'

export default {
	name: 'ImageModal',
	mixins: [ModalMixin],
	components: {
		ImageInfo,
		WikidataTags,
		WikidataSearch,
		ReportedIssues
	},
	computed: {
		...mapGetters([
			'image'
		]),
		modalKey() {
			// Changing the key re-renders the modal.
			return 'image-modal-' + this.image.id;
		}
	},
	methods: {
		openseadragon() {
			var tileSources = null;
			
			if (typeof this.image.iiif_info.sizes !== 'undefined' && this.image.iiif_info.sizes.length > 0) {
				console.log('tiles');
				tileSources = {
					"@context": "http://iiif.io/api/image/2/context.json",
			        "@id": this.image.iiif_root,
			        "profile": ["http://iiif.io/api/image/2/level2.json"],
			        "protocol": "http://iiif.io/api/image",
			        "width": this.image.iiif_info.width,
			        "height": this.image.iiif_info.height,
					"tiles": [{
				        "scaleFactors": this.image.iiif_info.tiles[0].scaleFactors,
				        "width": this.image.iiif_info.sizes[1].width,
				    }]
				};
			} else {
				console.log('no tiles');
				tileSources = {
		            type: 'image',
		            url:  this.image.iiif_root + '/full/full/0/default.jpg'
		        };
			}
			
			this.viewer = OpenSeadragon({
				id: 'openseadragon',
				tileSources: tileSources,
				zoomInButton:   'zoom-in',
				zoomOutButton:  'zoom-out',
				homeButton:		'home',
				showFullPageControl: false
			});
			
			this.configureOpenseadragon();
		},
		onSelectedTag(tag) {
			axios.post('/image/tag/save', {id: this.image.id, tag: tag}).then(response => {
				// Update the current list of tags.
				this.image.tags.push(response.data);
				updateTagsCount(this.image);
			}).catch(err => {
				console.log(err.response.data.message);
			})
		},
		onDeselectedTag(tag) {
			axios.post('/image/tag/delete', {tag: tag}).then(response => {
				this.image.tags.splice(this.image.tags.indexOf(tag), 1);
				updateTagsCount(this.image);
			}).catch(err => {
				console.log(err)
			})
		},
		onReported(issueType) {
			Vue.set(this.image, 'is_reported', 1);
			Vue.set(this.image, 'reported_issue_type', issueType);
		},
		onUnreported() {
			Vue.set(this.image, 'is_reported', 0);
		}
	}
}
</script>